<template>
  <div>
    <ButtonX />
    <b-container>
      <h1 id="wie-gut-kennen-wir-einander">Wie gut kennen wir einander?</h1>
      <p>
        Anhand einer Umfrage wird deutlich, wie gut sich Ost- und Westdeutschland wirklich kennen. Hierzu gab es drei
        leitende Fragen, deren Beantwortungen unter Ost- und Westdeutschland aufgeteilt wurden. Die Teilnehmer der Umfrage
        kamen aus verschiedenen Alters- und Bildungsschichten, allerdings waren sie hautpsächlich aus Westdeutschland und
        von einem höheren Bildungsniveau.
      </p>

      <p>Bei den beiden unteren Fragen ist jeweils die Anzahl der Angaben der jeweiligen Stadt/des jeweiligen Flusses angegeben. Das obere Diagram zeigt hier die Antworten der Befragten aus dem Osten und das Untere die der Befragten aus dem Westen.</p>
      <h2 id="nennen-sie-drei-universitätsstädte-des-jeweilig-anderen-landesteils.">
        Nennen Sie drei Universitätsstädte des
        jeweilig anderen Landesteils.
      </h2>
      <div class="py-5">
        <img src="../media/umfrage/UniWest.png" />
        <img src="../media/umfrage/UniOst.png" width="789" />
      </div>
      <h2 id="nennen-sie-zwei-flüsse-des-jeweilig-anderen-landesteils.">
        Nennen Sie zwei Flüsse des jeweilig anderen
        Landesteils.
      </h2>

      <div class="py-5">
        <img src="../media/umfrage/FlusWest.png" />
        <img src="../media/umfrage/FlusOst.png" />
      </div>
      <h2 id="nennen-sie-drei-landeshauptstädte-des-jeweilig-anderen-landesteils.">
        Nennen Sie drei Landeshauptstädte des
        jeweilig anderen Landesteils.
      </h2>

      <div class="py-5">
        <div class="umfrage">
          <img src="../media/umfrage/LaHaOst.png" />
          <img src="../media/umfrage/LaHaWest.png" width="390" />
        </div>
        <p>
          <i>
            links - Befragte aus dem Osten, rechts - Befragte aus dem Westen
            <br />hellblau - drei korrekte Antworten, blau -
            maximal zwei Korrekte Antworten, dunkelblau - keine Antwort
          </i>
        </p>
      </div>
      <div class="bib">
        <h2 class="bib">Quellen</h2>
        <p class="bib">Onlineumfragen, durchgeführt im Herbst 2020</p>
      </div>
      <Footer />
    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>